var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.284,
    height: 28.094,
    viewBox: "0 0 25.284 28.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "documento",
    d: "M4.646,3.646C3,5.291,3,7.94,3,13.238v5.619c0,5.3,0,7.946,1.646,9.592s4.294,1.646,9.592,1.646h2.809c5.3,0,7.946,0,9.592-1.646s1.646-4.294,1.646-9.592V13.238c0-5.3,0-7.946-1.646-9.592S22.344,2,17.047,2H14.238C8.94,2,6.291,2,4.646,3.646ZM8.97,10.428a1.054,1.054,0,0,1,1.054-1.054H21.261a1.054,1.054,0,1,1,0,2.107H10.023A1.054,1.054,0,0,1,8.97,10.428Zm0,5.619a1.054,1.054,0,0,1,1.054-1.054H21.261a1.054,1.054,0,1,1,0,2.107H10.023A1.054,1.054,0,0,1,8.97,16.047Zm1.054,4.565a1.054,1.054,0,0,0,0,2.107h7.023a1.054,1.054,0,0,0,0-2.107Z",
    transform: "translate(-3 -2)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.048e7a04dca9a36af5716886fbcb39ca.svg";
export { ForwardRef as ReactComponent };